var React = require('react');
var ReactRouter = require('react-router');
var History = ReactRouter.History;
var Link = ReactRouter.Link;
var ReactDOM = require('react-dom');
var Reflux = require('reflux');
var Shopify = require('./shopify');
var ScreenWidStore = require('./stores/screen-wid-store');

var SearchBox = React.createClass({

  render: function() {

    return <div id="search" onClick={this.props.handleClick}>
            <i className="icon-search" ></i>
      </div>
  }
});

var BagMenu = React.createClass({

  cartContent: {},
  showBagWhenCartGot: false,
  sliding: false,
  mouseIn: false,

  getInitialState: function() {

    return { cartRows: [],
                     itemCount: 0,
             subTotal: 0 }
  },

  setNumItems: function(numItems) {

    this.setState({ itemCount: numItems });
  },

  handleMouseOver: function() {
    this.props.handleMouseOverBag();
  },

  handleMouseOut: function() {
    this.props.handleMouseOutBag();
  },


  render: function() {

    return <div onMouseOver={this.handleMouseOver}
                onMouseLeave={this.handleMouseOut} id="bag-menu">
          <Link to="/cart" className="cart" title="Shopping Cart">
              BAG {this.state.itemCount ? '(' + this.state.itemCount + ')' : ''}
          </Link>
          
      </div>
  }
});

var BagDropdown = React.createClass({

  getInitialState: function() {
    //jQuery(ReactDOM.findDOMNode(this.refs.itemList)).css('display', 'none');
    return { cartRows: "",
             subTotal: 0 }
  },

  handleMouseOver: function() {
    this.props.handleMouseOverBag();
  },

  handleMouseOut: function() {
    this.props.handleMouseOutBag();
  },

  createCartRows: function(items) {
    if (items.length) {
      jQuery(ReactDOM.findDOMNode(this.refs.noItem)).css('display', 'none');
      jQuery(ReactDOM.findDOMNode(this.refs.subTotal)).css('display', 'block');
      jQuery(ReactDOM.findDOMNode(this.refs.itemList)).css('display', 'block');
      return items.map(function(item) {
        return <li key={item.id}>
                 <div className="row popup-cart-row">
                     <div className="col-xs-6 img-wrap">
                         <a href={"/products/" + item.handle}>
                             <img src={item.image ? item.image : ImageUrl.dummyShoe}/>
                         </a>
                     </div>
                     <div className="col-xs-6 text-wrap">
                         <p><span className="prod-title">{item.product_title}</span><br/>
                            <span className="prod-info">{item.variant_options[1] + " - " + item.variant_options[2]}<br/>
                            {'$' + (item.price / 100).toFixed(2)}<br/>
                            QTY: {item.quantity}</span>
                         </p>
                     </div>
                  </div>
              </li>
      });
    } else {
      jQuery(ReactDOM.findDOMNode(this.refs.subTotal)).css('display', 'none');
      jQuery(ReactDOM.findDOMNode(this.refs.itemList)).css('display', 'none');
      jQuery(ReactDOM.findDOMNode(this.refs.noItem)).css('display', 'block');
    }
  },

  setCartContent: function(cart) {
    this.setState({ cartRows: this.createCartRows(cart.items),
                    subTotal: '$' + (cart.total_price / 100).toFixed(2) });
  },

  render: function() {
    return <div ref="bagContent" id="bag-popup" onMouseOver={this.handleMouseOver}
                onMouseLeave={this.handleMouseOut}>
              <h3>Your Shopping Bag</h3>
              <ul ref="itemList">
                  {this.state.cartRows}
              </ul>
              <p ref="noItem" className="bag-empty-msg">Bag is currently empty.</p>
              <div className="sub-div" ref="subTotal">
                  <p className="sub-text">SUB TOTAL</p>
                  <p className="sub-price">{this.state.subTotal}</p>
              </div>
          </div>
  }
});

module.exports = React.createClass({

  mixins: [ History,
            Reflux.listenTo(ScreenWidStore, "screenWidthCrossMD") ],

  smallScreen: false,
  
  genderSubMenuOpened: false,
  genderSubMenuClosed: true,
  genderSubMenuSlidingDown: false,
  genderSubMenuSlidingUp: false,
  mouseInGender: false,
  mouseInSubMenu: false,

  showBagWhenCartGot: false,
  bagSliding: false,
  mouseInBag: false,

  getInitialState: function() {
    var sticky = 0 == this.props.curPath.indexOf('/collections/') || 
                 0 == this.props.curPath.indexOf('/pages/brands');
    return { subMenuWomens: [],
             subMenuMens: [],
             subMenuSticky: "LG" == ScreenWidStore.width && sticky }
  },

  screenWidthCrossMD: function(event, width) {      

    var searchBox = jQuery(ReactDOM.findDOMNode(this.refs.searchBox)).detach();
    var toolsDiv = jQuery(ReactDOM.findDOMNode(this.refs.toolsDiv)).detach();

    if ("LG" == width) {
      toolsDiv.prepend(searchBox);
      toolsDiv.insertBefore(jQuery(this.refs.mainNavBar));
      this.smallScreen = false;
    } else {
      toolsDiv.insertBefore(jQuery(ReactDOM.findDOMNode(this.refs.mainNavBar)));
      jQuery(ReactDOM.findDOMNode(this.refs.mainNavBar)).append(searchBox);
      this.smallScreen = true;
    }
  },

  componentDidMount: function() {
    Shopify.getCartContent(this.cartContentGot);

    if (this.props.curPath != "/") {
      _.map(jQuery(this.refs.links).find('li'),
            function(el) {
              var aTag = jQuery(el).find('a');

              if (aTag.length) {
                if (aTag[0].href.indexOf(this.props.curPath) >= 0) {
                  jQuery(el).addClass('active');
                }
              }}.bind(this));
    }

    if ("LG" == ScreenWidStore.width) {
      this.smallScreen = false;
    } else {
      var searchBox = jQuery(ReactDOM.findDOMNode(this.refs.searchBox)).detach();
      var toolsDiv = jQuery(ReactDOM.findDOMNode(this.refs.toolsDiv)).detach();

      jQuery(ReactDOM.findDOMNode(this.refs.container)).append(toolsDiv);
      jQuery(ReactDOM.findDOMNode(this.refs.mainNavBar)).append(searchBox);
      this.smallScreen = true;
    }
    if ("LG" == ScreenWidStore.width) {
      this.stickySubMenu(this.state.subMenuSticky, this.props.curPath);
    }
  },

  componentWillReceiveProps: function(nextProps) {
    if ("LG" == ScreenWidStore.width) {
      var sticky = 0 == nextProps.curPath.indexOf('/collections/') || 
                   0 == nextProps.curPath.indexOf('/pages/brands');
      this.setState({ subMenuSticky: sticky });
      this.stickySubMenu(sticky, nextProps.curPath);
    }
  },

  stickySubMenu: function(subMenuSticky, curPath) {
    if (subMenuSticky) {
      var forWomens = curPath.toLowerCase().indexOf('womens') >=0;
      

      jQuery(this.refs.subMenu).css('display', 'block');

      if (forWomens) {
        jQuery(this.refs.subMenuWomens).css('display', 'block');
        jQuery(this.refs.subMenuMens).css('display', 'none');        
      } else {
        jQuery(this.refs.subMenuWomens).css('display', 'none');
        jQuery(this.refs.subMenuMens).css('display', 'block');        
      }
      jQuery('#submenu').css('top', 'auto');
      var h = jQuery('.nav-top').outerHeight() + jQuery('.main-nav').outerHeight() + jQuery('#submenu').outerHeight();
      jQuery('body').css('padding-top', h);
      
    } else {
      jQuery(this.refs.subMenu).css('display', 'none');
      this.genderSubMenuClosed = true;
      var h = jQuery('.nav-top').outerHeight() + jQuery('.main-nav').outerHeight();
      jQuery('body').css('padding-top', h);
    }
    
  },

  cartContentGot: function(cart) {
    if (cart.items) {
      var numTotalItem = _.reduce(cart.items, function(result, item) { 
                                                result += item.quantity;
                                                return result;
                                              }, 0);
      this.refs.bagMenu.setNumItems(numTotalItem);
      this.refs.bagDropdown.setCartContent(cart);

    }
    if (this.showBagWhenCartGot) {
      this.dropdownBag();
    }
  },

  updateBag: function(cart) {
    this.cartContentGot(cart);
  },

  handleMouseOverBag: function() {
    if (this.smallScreen) return;

    this.mouseInBag = true;
    if (!this.bagSliding) {
      this.bagSliding = true;
      jQuery(ReactDOM.findDOMNode(this.refs.bagDropdown))
        .slideDown(function() { 
                     this.bagSliding = false;
                     if (!this.mouseInBag) this.closeBagIfNotMouseIn();
                   }.bind(this));
    }
  },

  handleMouseOutBag: function() {
    this.mouseInBag = false;
    if (!this.bagSliding) {
      var self = this;
      setTimeout(function(){ 
                   if (!self.mouseInBag) {
                     self.closeBagIfNotMouseIn();
                   }
                 }, 500);
    }
  },

  closeBagIfNotMouseIn: function() {
    if (!this.mouseInBag) {
      this.closeBag();
    }
  },

  closeBag: function() {
    this.bagSliding = true;
    jQuery(ReactDOM.findDOMNode(this.refs.bagDropdown))
        .slideUp(function() {
          this.bagSliding = false;
          if (this.mouseInBag) {
            this.handleMouseOverBag();
          }
        }.bind(this));
  },

  showBag: function() {
    this.showBagWhenCartGot = true;
    Shopify.getCartContent(this.cartContentGot);
  },

  handleMenuClicked: function(e) {
    if (jQuery(this.refs.mobileMenuBtn).is(':visible')) {
      jQuery(this.refs.mobileMenuBtn).click();
    }
    _.map(jQuery(e.target).parents('ul').find('li'),
          function(el) { jQuery(el).removeClass('active') });
    jQuery(e.target).parents('li').addClass("active");
  },

  clearMenuActive: function() {
    if (jQuery(ReactDOM.findDOMNode(this.refs.mainNavBar)).is(':visible')) {
      if ("SM" == ScreenWidStore.width) {
        jQuery(this.refs.mobileMenuBtn).click();
      }
    }
    _.map(jQuery(this.refs.links).find('li'),
          function(el) { jQuery(el).removeClass('active') });
  },

  dropdownBag: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.bagDropdown)).slideDown(function() {
                                                                    this.bagSliding = false;
                                                                  }.bind(this));
    this.bagSliding = true;
    setTimeout(this.closeBagIfNotMouseIn, 2000);
    this.showBagWhenCartGot = false;
  },

  handleMouseOverWomens: function() {

    if (this.smallScreen) return;
    this.mouseInGender = true;
    jQuery(this.refs.subMenuWomens).css('display', 'block');
    jQuery(this.refs.subMenuMens).css('display', 'none');
    if (this.genderSubMenuClosed) {
      this.openSubMenu();
    }
  },

  handleMouseOverMens: function() {

    if (this.smallScreen) return;
    this.mouseInGender = true;
    jQuery(this.refs.subMenuWomens).css('display', 'none');
    jQuery(this.refs.subMenuMens).css('display', 'block');
    if (this.genderSubMenuClosed) {
      this.openSubMenu();
    }
  },

  handleMouseOutGender: function() {
    this.mouseInGender = false;
    if (this.genderSubMenuOpened) {
      setTimeout(this.checkIfNeedClose, 500);
    }
  },

  handleOverSubMenu: function() {
    this.mouseInSubMenu = true;
  },

  handleLeaveSubMenu: function() {
    this.mouseInSubMenu = false;
    if (this.genderSubMenuOpened) {
      setTimeout(this.checkIfNeedClose, 500);
    }
  },

  openSubMenu: function() {
    this.genderSubMenuSlidingDown = true;
    this.genderSubMenuClosed = false;
    jQuery(this.refs.subMenu).slideDown(this.checkIfNeedClose);
  },

  checkIfNeedClose: function() {
    if (!(this.mouseInGender || this.mouseInSubMenu)) {
      this.genderSubMenuSlidingUp = true;
      this.genderSubMenuOpened = false;
      jQuery(this.refs.subMenu).slideUp(this.checkIfNeedOpen);
    } else {
      this.genderSubMenuOpened = true;
    }
  },

  checkIfNeedOpen: function() {
    if (this.mouseInGender || this.mouseInSubMenu) {
      this.genderSubMenuSlidingDown = true;
      this.genderSubMenuClosed = false;
      jQuery(this.refs.subMenu).slideDown(this.checkIfNeedClose);
    } else {
      this.genderSubMenuClosed = true;
    }
  },

  handleKeyDown: function(e) {
    if ('Enter' == e.key){
      this.history.pushState(null, '/pages/search/' + encodeURIComponent(jQuery(this.refs.searchTerms).val()));
      jQuery(ReactDOM.findDOMNode(this.refs.searchBar)).slideToggle();
      jQuery('#search-text').val('');
    }
  },

  handleBlur: function(e) {
    if (navigator.userAgent.match(/iPhone|iPod/i)) {
      this.history.pushState(null, '/pages/search/' + encodeURIComponent(jQuery(this.refs.searchTerms).val()));
      jQuery(ReactDOM.findDOMNode(this.refs.searchBar)).slideToggle();
      jQuery('#search-text').val('');
    }
  },
  
  showSearch: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.searchBar)).slideToggle();
    if (jQuery(this.refs.mobileMenuBtn).is(':visible')) {
      jQuery(this.refs.mobileMenuBtn).click();
    }
  },

  hideSearchBar: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.searchBar)).slideUp();
  },

  setSubMenuSticky: function() {
    this.setState({ subMenuSticky: true });
  },

  render: function() {

    var i = 0;
    var menus = [<Link to={"/collections/womens"} key={"womens0"} >COLLECTIONS</Link>];

    var subMenuWomens = _.reduce(CMS.womens.categories, function(acc, menu) {
      i++;
      acc.push(<Link to={menu.url} key={"womens" + i}>{menu.title}</Link>);
      return acc;
    }.bind(this), menus);

    i = 0;
    menus = [<Link to={"/collections/mens"} key={"mens0"}>COLLECTIONS</Link>];
    var subMenuMens = _.reduce(CMS.mens.categories, function(acc, menu) {
      i++;
      acc.push(<Link to={menu.url} key={"mens" + i}>{menu.title}</Link>);
      return acc;
    }.bind(this), menus);

    return <nav className="navbar navbar-default navbar-fixed-top" role="navigation">
            <div className="nav-top">
                <div className="container">
                    <Link to="/pages/shipping-returns"><strong>FREE SHIPPING On Orders Of $190 Or More.</strong></Link>
                </div>
            </div>
            <div ref="container" className="main-nav container" >

                <div className="navbar-header" >
                    <button className="navbar-toggle collapsed pull-left" data-toggle="collapse"
                            data-target="#main-navbar-collapse">
                      <span className="sr-only" >Navigation toggle</span>
                      <span ref="mobileMenuBtn" >MENU</span>
                    </button>
                    <Link to="/" className="navbar-brand">
                        <img src={ImageUrl.logo} alt="logo" onClick={this.clearMenuActive} />
                    </Link>
                </div>
                <div id="tools" ref="toolsDiv" >
                    <SearchBox ref="searchBox" handleClick={this.showSearch} />
                    <BagMenu ref="bagMenu" handleMouseOverBag={this.handleMouseOverBag}
                             handleMouseOutBag={this.handleMouseOutBag} />
                </div>
                <div ref="mainNavBar" className="collapse navbar-collapse" id="main-navbar-collapse">
                  <ul ref="links" className="nav navbar-nav navbar-right" role="menu">
                    <li>
                        <Link to="/pages/art-of-fit" onClick={this.handleMenuClicked}>ART OF FIT
                            <div className="for-underline"></div>
                        </Link>
                    </li>
                    <li onMouseOver={this.state.subMenuSticky ? null : this.handleMouseOverWomens} 
                        onMouseLeave={this.state.subMenuSticky ? null : this.handleMouseOutGender}>
                        <Link to="/collections/womens" onClick={this.handleMenuClicked}>SHOP WOMEN'S
                            <div className="for-underline"></div>
                        </Link>
                    </li>
                    <li onMouseOver={this.state.subMenuSticky ? null : this.handleMouseOverMens}
                        onMouseLeave={this.state.subMenuSticky ? null : this.handleMouseOutGender}>
                        <Link to="/collections/mens" onClick={this.handleMenuClicked}>SHOP MEN'S
                            <div className="for-underline"></div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/pages/stores" onClick={this.handleMenuClicked}>OUR STORES
                            <div className="for-underline"></div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/pages/style-tips" onClick={this.handleMenuClicked}>STYLE TIPS
                            <div className="for-underline"></div>
                        </Link>
                    </li>
                  </ul>
                </div>
                <BagDropdown ref="bagDropdown" handleMouseOverBag={this.handleMouseOverBag}
                             handleMouseOutBag={this.handleMouseOutBag} />
            </div>
            <div id="submenu" ref="subMenu" 
                 onMouseOver={this.state.subMenuSticky ? null : this.handleOverSubMenu}
                 onMouseLeave={this.state.subMenuSticky ? null : this.handleLeaveSubMenu} >
                <div className="container">
                    <div className="submenu-inner" ref="subMenuWomens">
                        <div id="submenu-womens">
                            {subMenuWomens}
                        </div>
                    </div>
                    <div className="submenu-inner" ref="subMenuMens">
                        <div id="submenu-mens">
                            {subMenuMens}
                        </div>
                    </div>
                </div>
            </div>
            <div ref="searchBar" id="searchbar">
                <div className="container">
                <input id="search-text"
                       onKeyDown={this.handleKeyDown}
                       onBlur={this.handleBlur}
                       type="text" ref="searchTerms" placeholder="type to search..."
                       ></input>
                <i className="icon-close" onClick={this.hideSearchBar} ></i>

                </div>
            </div>
        </nav>
    }
})